/**
 * ["A1", "A2", "A26", "A27", "C1", "C2", "C3"]과 같은 문자열 배열을 "A1 ~ A2, A26 ~ A27, C1 ~ C3" 형태로 반환한다.
 * @param gateNames - ["A1", "A2", "A26", "A27", "C1", "C2", "C3"] 등 탑승 게이트 이름 배열
 * @returns "C1 ~ C3, A1 ~ A2, A26 ~ A27"
 */
export function convertToRangeGateNames(gateNames: string[]): string {
  if (!gateNames.length) return "";

  // 접두사(prefix)별로 숫자 목록을 저장할 그룹 객체
  const groups: Record<string, number[]> = {};
  // 숫자 규칙에 맞지 않는 문자열 저장용 배열
  const others: string[] = [];

  for (const item of gateNames) {
    // "A1", "2-5" 등 다양한 prefix+number 패턴 지원
    const match = item.match(/^([A-Za-z0-9-]+?)(\d+)$/);

    if (match) {
      const [, prefix, number] = match;
      const num = parseInt(number, 10);
      // 그룹이 존재하지 않으면 초기화
      if (!groups[prefix]) groups[prefix] = [];

      // 해당 접두사 그룹에 숫자 추가
      groups[prefix].push(num);
    } else {
      // 정규식에 매칭되지 않는 항목은 따로 저장
      others.push(item);
    }
  }

  const result: string[] = [];

  // 각 접두사 그룹에 대해 정렬 후 연속 구간 압축 처리
  for (const [prefix, numbers] of Object.entries(groups)) {
    numbers.sort((a, b) => a - b); // 숫자 오름차순 정렬

    let start = numbers[0]; // 현재 구간 시작 숫자
    let prev = start; // 직전 숫자 (연속 여부 판단용)

    for (let i = 1; i <= numbers.length; i++) {
      const curr = numbers[i];

      // 연속이 끊긴 경우, 또는 마지막 요소 처리
      if (curr !== prev + 1) {
        if (start === prev) {
          // 단일 숫자인 경우
          result.push(`${prefix}${start}`);
        } else {
          // 연속 구간인 경우
          result.push(`${prefix}${start}~${prefix}${prev}`);
        }
        // 다음 구간 시작
        start = curr;
      }

      prev = curr;
    }
  }

  // 숫자 규칙이 아닌 나머지 항목을 사전순으로 정렬 후 추가
  others.sort();
  result.push(...others);

  return result.join(", ");
}
